module.exports = __webpack_public_path__ + "img/MTW.35732bee.jpg";